(function () {
  function trackAblyftGoal(eventName) {
    if (!eventName) return;

    window.ablyft = window.ablyft || [];
    window.ablyft.push({
      eventType: 'custom',
      eventName: eventName
    });
  }

  function quickGoalSlug(text) {
    return (text || '')
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function initSliderDrag(track) {
    if (!track || track.dataset.nhDragScrollReady === 'true') return;
    track.dataset.nhDragScrollReady = 'true';

    var isDown = false;
    var dragged = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse') return;
      isDown = true;
      dragged = false;
      startX = event.clientX;
      startScroll = track.scrollLeft;
    });

    window.addEventListener('pointermove', function (event) {
      if (!isDown) return;
      var delta = event.clientX - startX;
      if (!dragged && Math.abs(delta) > 4) {
        dragged = true;
        track.style.scrollSnapType = 'none';
      }
      if (dragged) {
        track.scrollLeft = startScroll - delta;
        event.preventDefault();
      }
    });

    window.addEventListener('pointerup', function () {
      if (!isDown) return;
      isDown = false;
      if (dragged) {
        window.setTimeout(function () {
          track.style.scrollSnapType = '';
        }, 60);
      }
    });

    track.addEventListener('click', function (event) {
      if (!dragged) return;
      event.preventDefault();
      event.stopPropagation();
      dragged = false;
    }, true);

    track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
  }

  function initMenu(drawer) {
    if (!drawer || drawer.dataset.nhMobileMenuReady === 'true') return;

    drawer.querySelectorAll('.header-mobile-menu-slider__track').forEach(initSliderDrag);

    var mainPanel = drawer.querySelector('#header-mobile-menu-main');
    var panels = drawer.querySelectorAll('[data-nh-menu-panel]');
    var openButtons = drawer.querySelectorAll('[data-nh-menu-open]');
    var backButtons = drawer.querySelectorAll('[data-nh-menu-back]');
    var drawerCloseButtons = drawer.querySelectorAll('.js-drawer-close');

    function isProductOrCollectionLink(link) {
      var linkType = link.dataset.nhMenuLinkType || '';
      var href = link.getAttribute('href') || '';

      return linkType === 'product_link' ||
        linkType === 'collection_link' ||
        href.indexOf('/products/') !== -1 ||
        href.indexOf('/collections/') !== -1;
    }

    function activatePanel(panelId, trigger) {
      var nextPanel = drawer.querySelector('#' + panelId);
      if (!nextPanel) return;

      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel === nextPanel);
        if (panel === mainPanel || panel === nextPanel) {
          panel.hidden = false;
        } else {
          panel.hidden = true;
        }
      });

      openButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', button === trigger ? 'true' : 'false');
      });

      drawer.classList.add('is-submenu-open');
      drawer.style.setProperty('--nh-menu-panel-index', 1);
      var backButton = nextPanel.querySelector('[data-nh-menu-back]');
      if (backButton) {
        window.setTimeout(function () {
          backButton.focus();
        }, 280);
      }

      trackAblyftGoal('nh_mobile_menu_submenu_open');
    }

    function closeSubmenu() {
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel === mainPanel);
        panel.hidden = panel !== mainPanel;
      });

      openButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });

      drawer.classList.remove('is-submenu-open');
      drawer.style.setProperty('--nh-menu-panel-index', 0);
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activatePanel(button.dataset.nhMenuOpen, button);
      });
    });

    backButtons.forEach(function (button) {
      button.addEventListener('click', closeSubmenu);
    });

    drawerCloseButtons.forEach(function (button) {
      button.addEventListener('click', closeSubmenu);
    });

    drawer.addEventListener('click', function (event) {
      var sliderTile = event.target.closest('.header-mobile-menu-slider__tile');
      if (sliderTile && drawer.contains(sliderTile)) {
        trackAblyftGoal('nh_mobile_menu_slider_product_click');
      }

      var sliderHead = event.target.closest('.header-mobile-menu-slider__head[data-nh-menu-open]');
      if (sliderHead && drawer.contains(sliderHead)) {
        trackAblyftGoal('nh_mobile_menu_bestseller_open');
      }

      var quickButton = event.target.closest('.header-mobile-menu-buttons__item');
      if (quickButton && drawer.contains(quickButton)) {
        var quickLabel = quickButton.querySelector('.header-mobile-menu-buttons__label');
        var quickSlug = quickGoalSlug(quickLabel ? quickLabel.textContent : '');
        if (quickSlug) {
          trackAblyftGoal('nh_mobile_menu_quick_' + quickSlug);
        }
      }

      var link = event.target.closest('a[href]');
      if (!link || !drawer.contains(link)) return;

      if (isProductOrCollectionLink(link)) {
        trackAblyftGoal('nh_mobile_menu_product_click');
      }
    });

    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-submenu-open')) {
        closeSubmenu();
      }
    });

    document.querySelectorAll('.js-drawer-open-nav[aria-controls="NavDrawer"]').forEach(function (button) {
      button.addEventListener('pointerdown', closeSubmenu);
      button.addEventListener('touchstart', closeSubmenu, { passive: true });
      button.addEventListener('mousedown', closeSubmenu);
      button.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          closeSubmenu();
        }
      });
    });

    function handleDrawerOpen() {
      closeSubmenu();

      if (drawer.classList.contains('drawer--is-open')) {
        trackAblyftGoal('nh_mobile_menu_open');
      }
    }

    document.addEventListener('drawerOpen.NavDrawer', handleDrawerOpen);
    document.addEventListener('drawerOpen.NavDrawerAB', handleDrawerOpen);
    drawer.dataset.nhMobileMenuReady = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-header-mobile-menu]').forEach(initMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
